export { getClientToken, submitPaymentNonce, postSubscription, postSubscriptionCS, getPayments } from './service';



// WEBPACK FOOTER //
// ./src/common/services/payment.service/index.js